// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import SmartDevice from "./SmartDevice.js";

var dashboardCommonJS = require("../../js/dashboardCommon.js")

const SmartDevicesGroup = (appsParam) => {

  useEffect(() => {                 
    console.log("Grupo de dispositivos cargado correctamente.")
  }, [appsParam.objListadoDispositivos]); 

  function obtenerLiteralGrupoDispositivos(tipoDispositivo){
    var literal = ""
  
    if(tipoDispositivo === "PERSIANA"){literal = "PERSIANAS"}
    else if(tipoDispositivo === "ENCHUFE"){literal = "ENCHUFES"}
    else if(tipoDispositivo === "ENCHUFE_MONITOR"){literal = "ENCHUFES CON MEDIDOR DE CONSUMO"}
    else if(tipoDispositivo === "MONITOR_CONSUMO"){literal = "MONITOR DE CONSUMO"}
    else if(tipoDispositivo === "MONITOR_CONSUMO_INTERRUPTOR"){literal = "MONITOR DE CONSUMO"}    
    else if(tipoDispositivo === "INTERRUPTOR"){literal = "INTERRUPTORES"}
    else if(tipoDispositivo === "RELE"){literal = "RELÉS"}
    else if(tipoDispositivo === "TEMPERATURA"){literal = "SENSORES DE TEMPERATURA"}
    else if(tipoDispositivo === "HUMEDAD"){literal = "SENSORES HUMEDAD"}
    else if(tipoDispositivo === "AUTOMATICO_CUADRO_LUZ"){literal = "INTERRUPTORES AUTOMÁTICOS"}    
    else if(tipoDispositivo.includes("LUZ")){literal = "LUCES"} //Mismo tipo con varios controles
    else if(tipoDispositivo === "TERMO"){literal = "TERMOS"}
    else if(tipoDispositivo === "ESTUFA"){literal = "ESTUFAS"}    
    else if(tipoDispositivo === "REGULADOR_INTENSIDAD"){literal = "REGULADORES DE INTENSIDAD"}        
    else if(tipoDispositivo === "MANDO_IR_WIFI"){literal = "MANDOS IR WIFI"}    
    else if(tipoDispositivo === "TV"){literal = "TELEVISIONES"}    
    else if(tipoDispositivo === "EQUIPO_SONIDO"){literal = "EQUIPOS DE SONIDO"}          
    else if( (tipoDispositivo === "AIRE_ACONDICIONADO") || (tipoDispositivo === "AIRE_ACONDICIONADO*DIRECTO") ){literal = "AIRES ACONDICIONADOS"}            
    else if(tipoDispositivo === "SERVIDOR_CAIDO"){literal = "APLICACIONES CON PROBLEMAS"}
    else if(tipoDispositivo === "VENTILADOR"){literal = "VENTILADORES"}
    else if(tipoDispositivo === "PROYECTOR"){literal = "PROYECTORES"}
    else if(tipoDispositivo === "TERMOSTATO"){literal = "TERMOSTATOS"}
    else if(tipoDispositivo === "PULSADOR"){literal = "PULSADORES"}
    else if(tipoDispositivo === "SENSOR_TEMPERATURA"){literal = "SENSORES TEMPERATURA"}
    else if(tipoDispositivo === "SENSOR_HUMEDAD"){literal = "SENSORES HUMEDAD"}
    else if(tipoDispositivo === "SENSOR_VOC"){literal = "SENSORES ORGÁNICOS"}
    else if(tipoDispositivo === "SENSOR_CH2O"){literal = "SENSORES FORMALDEHíDO"}
    else if(tipoDispositivo === "SENSOR_CO2"){literal = "SENSORES CO2"}
    else if(tipoDispositivo === "MANDOS_A_DISTANCIA"){literal = "MANDOS A DISTANCIA"}
    else if(tipoDispositivo === "DECODIFICADOR"){literal = "DECODIFICADOR"}
    else if(tipoDispositivo === "TV_BOX"){literal = "TV BOX"}
    else if(tipoDispositivo === "SENSOR_PUERTA_VENTANA"){literal = "SENSORES PUERTA | VENTANA"}
    else if(tipoDispositivo === "ESCENA"){literal = "ESCENAS"}
    else if(tipoDispositivo === "CALENTADOR_PISCINA"){literal = "PISCINAS"}
    else if(tipoDispositivo === "LAVADORA"){literal = "LAVADORAS"}
    else { literal = "OTROS"}
  
    return literal
  }

  function obtenerColorIcono(tipoDispositivo){
    var color = ""
  
    if(tipoDispositivo === "SERVIDOR_CAIDO"){color = "red"}
    else { color = "cyan"}
  
    return color 
  }


  const listSmartDevices = appsParam.objListadoDispositivos.map((smartDevice, index) =>
        
    [ appsParam.tipoDispositivo === smartDevice.TipoDispositivo.split("*")[0] ?      
      <SmartDevice key={"SDGSD"+index+smartDevice.IdDispositivo} smartDevice={smartDevice}/>          
      : 
      <React.Fragment key={"SDGSD"+index+smartDevice.IdDispositivo}/>
    ]
    
  );    

  return (        
    
    <details id={"detail"+appsParam.tipoDispositivo} className="accordion ">
      <summary className="title">
        <figure className={"avatar size-m "+obtenerColorIcono(appsParam.tipoDispositivo)}><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(appsParam.tipoDispositivo)}</span></figure>                    
        <span>{obtenerLiteralGrupoDispositivos(appsParam.tipoDispositivo)}</span>
      </summary>    

      { appsParam.tipoDispositivo === "PENDIENTE_INTEGRAR" ?
        <div className="message warning left">          
          <p className="size-s">Todavía no sé cómo controlar estos dispositivos, si quieres que aprenda a controlarlos envía un mensaje desde la opción de <strong>Menú → Ayuda y soporte</strong> indicando el modelo y marca o un enlace a una web donde se vean las especificaciones del mismo y aprenderé a controlarlo. Disculpa las molestias.</p>                              
        </div>
      :
        <></>
      }

      <ul className="list with-dividers">        
        {listSmartDevices} 
      </ul>  
    </details>        
    
  )  
  
}

export default SmartDevicesGroup